// Stub for Dropbox provider — not used in xtracker.
var Dropbox = function(){
	var me = {};
	me.init = function(){};
	me.connect = function(){};
	return me;
}();

export default Dropbox;
